import type { AuthInstance, CleanCognitoUserAttributes } from "../types";
import { wrapper } from "./wrapper";

export const checkAuth =
  (client: AuthInstance) => async (): Promise<CleanCognitoUserAttributes> => {
    const user = await client.currentAuthenticatedUser();
    const attributes = await wrapper(async () => client.userAttributes(user));
    const session = await wrapper(async () => client.currentSession());

    const userAttributes = attributes.reduce((acc, el) => {
      const name = el.getName();
      // remap 'custom prop to id'
      const key = name === "custom:alid" ? "id" : name;

      acc[key as keyof CleanCognitoUserAttributes] = el.getValue();
      return acc;
    }, {} as CleanCognitoUserAttributes);

    // remap id to sub if it exists, will keep things backwards compatible
    if (userAttributes.id) {
      userAttributes.sub = userAttributes.id;
    }

    userAttributes.token = session.getIdToken().getJwtToken();

    return userAttributes;
  };
